/**
 * Mailing list (raffles, events, newsletter) — see docs/mailing-plan.md.
 * Pass the Supabase access token when signed in: the API then subscribes the
 * session's own email straight away instead of sending a double opt-in email.
 */

export const MAILING_TOPICS = ['rifas', 'eventos', 'newsletter'];

async function request(path, { method = 'GET', body, accessToken } = {}) {
  const headers = {};
  if (body) headers['Content-Type'] = 'application/json';
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
  const res = await fetch(path, { method, headers, body: body ? JSON.stringify(body) : undefined });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    const err = new Error(json.error || 'Error al guardar tu suscripción');
    err.status = res.status;
    throw err;
  }
  return json;
}

/** → { status: 'subscribed' | 'pending' | ... } */
export function subscribeMailing({ email, name, source, topics, locale, onlyIfNew }, accessToken) {
  return request('/api/mailing/subscribe', {
    method: 'POST',
    body: { email: email?.trim(), name: name?.trim() || undefined, source, topics, locale, onlyIfNew },
    accessToken,
  });
}

/** Double opt-in link → { subscriber: { email, status, topics, token } } */
export function confirmMailing(token) {
  return request('/api/mailing/confirm', { method: 'POST', body: { token } });
}

export function getMailingPreferences(token) {
  return request(`/api/mailing/preferences?t=${encodeURIComponent(token)}`);
}

export function saveMailingPreferences(token, { topics, unsubscribeAll = false }) {
  return request('/api/mailing/preferences', { method: 'POST', body: { token, topics, unsubscribeAll } });
}

/** Signed-in user's own subscription → { subscriber: {...} | null } */
export function getMyMailing(accessToken) {
  return request('/api/mailing/me', { accessToken });
}

export function saveMyMailing(accessToken, { topics, name, locale }) {
  return request('/api/mailing/me', { method: 'POST', body: { topics, name, locale }, accessToken });
}
